import { render, staticRenderFns } from "./faceAuthenticationWarning.vue?vue&type=template&id=18ba56f1&scoped=true"
import script from "./faceAuthenticationWarning.vue?vue&type=script&lang=js"
export * from "./faceAuthenticationWarning.vue?vue&type=script&lang=js"
import style0 from "./faceAuthenticationWarning.vue?vue&type=style&index=0&id=18ba56f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba56f1",
  null
  
)

export default component.exports